import axios, { AxiosRequestConfig } from 'axios'
import {
  ReadSfBankAccountsRequestDto,
  ReadSfBankAccountsResponseDto,
  CreateSfBankAccountRequestDto,
  CreateSfBankAccountResponseDto,
  UpdateSfBankAccountRequestDto,
  UpdateSfBankAccountResponseDto,
  ReadUserSfBankAccountRequestDto,
  ReadUserSfBankAccountResponseDto,
  AssignSfBankAccountToUserRequestDto,
  AssignSfBankAccountToUserResponseDto,
  UnassignSfBankAccountFromUserRequestDto,
  UnassignSfBankAccountFromUserResponseDto,
} from '@sparling/financial-common'
import { isNil } from 'lodash'

export const fetchSfBankAccounts = async (
  { token, ...params }: ReadSfBankAccountsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadSfBankAccountsResponseDto> => {
  const response = await axios.get<ReadSfBankAccountsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/sf-bank-accounts`,
    {
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const createSfBankAccount = async (
  { token, ...params }: CreateSfBankAccountRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateSfBankAccountResponseDto> => {
  const response = await axios.post<CreateSfBankAccountResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/sf-bank-accounts`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateSfBankAccount = async (
  { token, id, ...params }: UpdateSfBankAccountRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateSfBankAccountResponseDto> => {
  const response = await axios.put<UpdateSfBankAccountResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/sf-bank-accounts/${id}`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const getAssignedAccountsByUser = async (
  { token, idSf, page, count }: ReadUserSfBankAccountRequestDto & { token: string },
  options: RequestInit = {},
): Promise<ReadUserSfBankAccountResponseDto> => {
  const response = await window.fetch(
    `${process.env.REACT_APP_SERVER_URL}/crm/user/assigned-accounts/${idSf}?page=${page}&count=${count || 10}`,
    {
      ...options,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...options.headers,
      },
    },
  )
  // eslint-disable-next-line no-return-await
  return await response.json()
}

export const getAssignedAccountIdsByUser = async (
  { token, idSf }: { token: string; idSf: string },
  options: RequestInit = {},
): Promise<number[]> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/assigned-account-ids/${idSf}`, {
    ...options,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
  // eslint-disable-next-line no-return-await
  return await response.json()
}

export const assignSfAccountToUser = async (
  { token, ...params }: AssignSfBankAccountToUserRequestDto & { token: string },
  options: RequestInit = {},
): Promise<AssignSfBankAccountToUserResponseDto> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/assign-account`, {
    ...options,
    body: JSON.stringify(params),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
  // eslint-disable-next-line no-return-await
  return await response.json()
}

export const unassignSfAccountFromUser = async (
  { token, ...params }: UnassignSfBankAccountFromUserRequestDto & { token: string },
  options: RequestInit = {},
): Promise<UnassignSfBankAccountFromUserResponseDto> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/unassign-account`, {
    ...options,
    body: JSON.stringify(params),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
  // eslint-disable-next-line no-return-await
  return await response.json()
}
